'use client'

// Сенсорный экран (палец, а не мышь). На нём системная клавиатура должна
// появляться только по нажатию в поле: где есть экранные клавиши
// (TrKeyboard) — не появляться вовсе, а сами мы фокус в поле не ставим.
// На сервере — false, после гидратации — по устройству.
import { useSyncExternalStore } from 'react'

const COARSE = '(pointer: coarse)'

function subscribe(cb: () => void) {
  const m = window.matchMedia(COARSE)
  m.addEventListener('change', cb)
  return () => m.removeEventListener('change', cb)
}

export function useCoarsePointer(): boolean {
  return useSyncExternalStore(subscribe, () => window.matchMedia(COARSE).matches, () => false)
}
